<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" custom-class="comn-dialog">
    <slot></slot>
    <template v-if="$slots.footer" v-slot:footer>
      <span class="dialog-footer">
        <slot name="footer"></slot>
      </span>
    </template>
  </el-dialog>
</template>

<script></script>

<style lang="scss">
.comn-dialog {
  border-radius: 15px 15px 15px 15px !important;
  overflow: visible !important;

  .el-dialog__header {
    background-color: #3a3f4d !important;
    margin-right: 0 !important;
    padding: 5px 20px;
    border-radius: 15px 15px 0 0 !important;
  }

  .el-dialog__title {
    color: #fff !important;
    font-size: 16px;
  }

  .el-dialog__headerbtn {
    top: -8px;
  }

  .el-dialog__body {
    overflow: visible !important;
  }

  .el-form,
  .el-form-item,
  .el-form-item__content {
    overflow: visible !important;
  }

  .dialog-footer {
    .el-button {
      width: 124px;
      height: 30px;
      border-radius: 15px;
      background-color: #d5d5d6;
    }

    .el-button.el-button--primary {
      background-color: #2988f4;
      border-radius: 15px;
    }
  }
}

.dialog-footer {
  .el-button {
    width: 124px;
    height: 30px;
    border-radius: 15px;
    background-color: #d5d5d6;
  }

  .el-button.el-button--primary {
    background-color: #2988f4;
    border-radius: 15px;
  }
}

/* CKEditor link / balloon 浮层 */
.ck.ck-balloon-panel,
.ck-body-wrapper {
  z-index: 3000 !important;
}
</style>